module.exports = __webpack_public_path__ + "img/procedure_01_sp_b.8f592c20.jpg";